import React from 'react';
import PartnerManagementPanel from '../PartnerManagementPanel';

const FinancialPartnersWorkspace = ({
  periodParams,
  onPartnersChanged,
  toast
}) => {
  return (
    <PartnerManagementPanel
      periodParams={periodParams}
      onPartnersChanged={onPartnersChanged}
      toast={toast}
    />
  );
};

export default FinancialPartnersWorkspace;
